import type { FC } from 'react';
import { Box } from '@material-ui/core';
import Chart from 'react-apexcharts';
import Title from 'src/components/admin/Title';

interface PropsAvanceMensualFacturacion {
  content: { labels: string[]; values: number[], totalBar: string };
}

const AvanceMensualFacturacion: FC<PropsAvanceMensualFacturacion> = ({
  content,
}) => {
  const title = 'Facturación por Convenio del mes , En MM de PEN';
  const chart = {
    options: {
      chart: {
        stacked: false,
        toolbar: {
          show: false,
        },
      },
      colors: ['#166aaa'],
      plotOptions: {
        bar: {
          distributed: true,
          horizontal: true,
          dataLabels: {
            position: 'top',
          },
        },
      },
      dataLabels: {
        enabled: true,
        offsetX: 60,
        style: {
          fontSize: '12px',
          colors: ['#001b46'],
        },
      },
      tooltip: {
        shared: true,
        intersect: false,
      },
      xaxis: {
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        labels: {
          show: false,
          rotate: -45,
        },
        categories: [...content.labels],
      },
      states: {
        active: {
          filter: {
            type: 'none',
          },
        },
        hover: {
          filter: {
            type: 'none',
          },
        },
      },
      legend: {
        show: false,
      },
    },
    series: [
      {
        name: 'Valor',
        data: [...content.values],
      },
    ],
  };

  return (
    <Box p={2}>
      <Title title={title} />
      <Title title={`Total: ${content.totalBar}`} />
      <Chart type="bar" {...chart} />
    </Box>
  );
};

export default AvanceMensualFacturacion;
